var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#09041C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2157_2653",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 17,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6504 26.6507V10.0166H10.0163V26.6507H26.6504Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.032552
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2157_2653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 26.1143C18.3333 26.1143 24.8131 22.3149 24.8131 16.9691C24.8131 13.3904 21.912 10.4893 18.3333 10.4893C14.7546 10.4893 11.8535 13.3904 11.8535 16.9691C11.8535 22.3149 18.3333 26.1143 18.3333 26.1143Z",
    stroke: "white",
    strokeWidth: 0.97656,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6895 16.8681C20.6895 18.1696 19.6345 19.2246 18.333 19.2246C17.0316 19.2246 15.9766 18.1696 15.9766 16.8681C15.9766 15.5667 17.0316 14.5117 18.333 14.5117C19.6345 14.5117 20.6895 15.5667 20.6895 16.8681Z",
    stroke: "white",
    strokeWidth: 0.97656,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryIcon);
export default __webpack_public_path__ + "static/media/country-icon.cfcbc4c718c15281e73900590133e157.svg";
export { ForwardRef as ReactComponent };